import React, {useEffect, useState} from 'react';
import Avatar from "@mui/material/Avatar";
import {authUser} from "./fake-db";
import {ListItemIcon, ListItemText, ThemeProvider, Typography} from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import RepeatOutlinedIcon from '@mui/icons-material/RepeatOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import {useNavigate} from "react-router-dom";
import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import Div from "@jumbo/shared/Div";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import {useSelector} from "react-redux";
import {CreditUser, defaultimage} from "../../../../api/api";
import {savecredit} from "../../../redux/actions/contactsApp";

const AuthUserDropdown = () => {
    const navigate = useNavigate();
    const {theme} = useJumboTheme();
    const {setAuthToken} = useJumboAuth();
    const {name, email, logo} = useSelector(({contactsApp}) => contactsApp);
    const [name0, setName0] = useState('');
    const [email0, setEmail0] = useState('');
    const [logo0, setLogo0] = useState('');


    useEffect(() => {
        setName0(name);
    }, [name]);

    useEffect(() => {
        setEmail0(email);
    }, [email]);

    useEffect(() => {
        setLogo0(logo);
    }, [logo]);


    const onLogout = () => {
        setAuthToken(null);
        localStorage.setItem('token', '');
        // localStorage.setItem('sd', 'sds');
        navigate("/user/login");
    };

    return (
        <ThemeProvider theme={theme}>
            <JumboDdPopover
                triggerButton={
                    <div
                        style={{display: 'flex', flexDirection: 'row',cursor:'pointer', justifyContent: 'center', alignItems: 'center'}}>
                        <div className="iran-font3" style={{marginLeft:10,fontWeight:'bold'}}>{localStorage.getItem('name')}</div>
                        <Avatar
                            // src={authUser.profile_pic}
                            src={defaultimage(logo0)}
                            sizes={"small"}
                            sx={{boxShadow: 25, cursor: 'pointer'}}
                        />
                    </div>
                }
            >
                <Div sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    p: theme => theme.spacing(2.5),
                }}>
                    <Avatar src={defaultimage(logo0)} alt={authUser.name} sx={{width: 60, height: 60, mb: 2}}/>
                    <Typography className="iran-font3" variant={"h5"}>{name0}</Typography>
                    <Typography className="iran-font3" variant={"body1"} color="text.secondary">{email0}</Typography>
                </Div>
                <Divider/>
                <nav>
                    <List disablePadding sx={{pb: 1}}>
                        {/*<ListItemButton onClick={() => navigate(`/editprofile`)}>*/}
                        {/*    <ListItemIcon sx={{minWidth: 36}}>*/}
                        {/*        <PersonOutlineIcon/>*/}
                        {/*    </ListItemIcon>*/}
                        {/*    <ListItemText primaryTypographyProps={{fontFamily: 'Iran !important', fontSize: 16}}*/}
                        {/*                  primary="پروفایل" sx={{my: 0}}/>*/}
                        {/*</ListItemButton>*/}
                        {/*<ListItemButton>*/}
                        {/*    <ListItemIcon sx={{minWidth: 36}}>*/}
                        {/*        <EditOutlinedIcon/>*/}
                        {/*    </ListItemIcon>*/}
                        {/*    <ListItemText primary="Edit Profile" sx={{my: 0}}/>*/}
                        {/*</ListItemButton>*/}
                        {/*<ListItemButton>*/}
                        {/*    <ListItemIcon sx={{minWidth: 36}}>*/}
                        {/*        <RepeatOutlinedIcon/>*/}
                        {/*    </ListItemIcon>*/}
                        {/*    <ListItemText onClick={() => navigate("/samples/content-layout")} primary="Switch User"*/}
                        {/*                  sx={{my: 0}}/>*/}
                        {/*</ListItemButton>*/}
                        <ListItemButton onClick={onLogout}>
                            <ListItemIcon sx={{minWidth: 36}}>
                                <LogoutIcon/>
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{fontFamily: 'Iran !important', fontSize: 16}}
                                          primary="خروج" sx={{my: 0}}/>
                        </ListItemButton>
                    </List>
                </nav>
            </JumboDdPopover>
        </ThemeProvider>
    );
};

export default AuthUserDropdown;
